// Module
var code = `<h2 class="margin-bottom margin-top-sm"><strong class="margin-right">3.</strong>Server Certificate Information</h2>
<form class="flex-form" data-bind="submit: save">
    <div class="panel padding padding-lg">
        <div data-bind="with: model.certificate">
            <div class="form-group" data-bind="validationElement: certificate">
                <label for="certificate" class="control-label">Certificate<i class="required"></i></label>
                <div class="flex-grow input-group file-input" data-bind="validationElement: certificate">
                    <input type="file" tabindex="-1" name="importFile" id="certificate" accept="" data-bind="event: { change: _.partial(\$root.fileSelected, \$element) }">
                    <span class="static-name form-control" data-bind="text: certificateFileName() || 'Select server certificate file (*.pfx)'">
                    </span>                   
                    <span class="input-group-btn">
                        <label for="certificate" class="btn btn-default">
                            <i class="icon-document"></i>
                            <span>Browse</span>
                        </label>
                    </span>
                    <p class="help-block" data-bind="validationMessage: certificate"></p>
                </div>
            </div>
            <div class="form-group" data-bind="validationElement: certificatePassword, visible: \$root.passwordInputVisible">
                <label for="certificatePassword" class="control-label">Passphrase</label>
                <div class="flex-grow">
                    <input type="password" autocomplete="off" class="form-control" id="certificatePassword" data-bind="textInput: certificatePassword" placeholder="Enter certificate password">
                </div>
            </div>
            <div class="form-group margin-bottom" data-bind="visible: certificateFileName() && certificateCNs().length !== 0">
                <label class="control-label">CN names</label>
                <div class="flex-grow">
                    <div class="d-flex flex-wrap flex-gap-gutter-xs" data-bind="foreach: certificateCNs">
                        <span class="badge" data-bind="text: \$data"></span>
                    </div>
                    <div data-bind="validationOptions: { errorsAsTitle: false }, validationElement: certificateCNs, visible: !\$root.spinners.hosts()">
                        <div class="help-block" data-bind="validationMessage: certificateCNs"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="navigation padding-md flex-horizontal">
        <button type="button" class="btn btn-default btn-lg" data-bind="click: \$root.back">
            <i class="icon-arrow-left"></i><span>Back</span>
        </button>
        <div class="flex-separator"></div>
        <button type="submit" class="btn btn-primary btn-lg">
            <span>Next</span> <i class="icon-arrow-right"></i>
        </button>
    </div>
</form>
      
`;
// Exports
export default code;